import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/line.png'
import _imports_1 from '../assets/nolines.png'
import _imports_2 from '../assets/validate.png'
import _imports_3 from '../assets/invalidate.png'


const _hoisted_1 = { class: "thumbnails-main" }
const _hoisted_2 = { class: "thumbnails-header" }
const _hoisted_3 = ["data-image-id", "onClick", "onContextmenu"]
const _hoisted_4 = ["src", "alt", "title", "width", "height", "onError"]
const _hoisted_5 = {
  key: 0,
  class: "thumb-nontrack-x",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 1,
  class: "presence-badges"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "thumbnails-footer" }
const _hoisted_9 = { class: "thumbnails-footer-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: _normalizeClass(["thumbnails-buttons", {'thumbnails-solo-lines-on':_ctx.soloLines}]),
        src: _imports_0,
        alt: "solo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSoloLines && _ctx.toggleSoloLines(...args))),
        title: "Show images with lines"
      }, null, 2),
      _createElementVNode("img", {
        class: _normalizeClass(["thumbnails-buttons", {'thumbnails-solo-nolines-on': _ctx.soloNoLines}]),
        src: _imports_1,
        alt: "no-lines",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNoLines && _ctx.toggleNoLines(...args))),
        title: "Show images without lines"
      }, null, 2),
      _createElementVNode("img", {
        class: _normalizeClass(["thumbnails-buttons", {'thumbnails-solo-validated-on': _ctx.soloValidated}]),
        src: _imports_2,
        alt: "validated",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleValidated && _ctx.toggleValidated(...args))),
        title: "Show validated images"
      }, null, 2),
      _createElementVNode("img", {
        class: _normalizeClass(["thumbnails-buttons", {'thumbnails-solo-invalidated-on': _ctx.soloInvalidated}]),
        src: _imports_3,
        alt: "invalidated",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleInvalidated && _ctx.toggleInvalidated(...args))),
        title: "Show invalidated images"
      }, null, 2)
    ]),
    _createElementVNode("div", {
      class: "thumbnails-content",
      ref: "thumbsScroll",
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      _createElementVNode("div", {
        class: "thumbnails",
        style: _normalizeStyle({ '--cell': _ctx.CELL_W + 'px' })
      }, [
        _createElementVNode("div", {
          class: "grid-pad",
          style: _normalizeStyle({ height: _ctx.padTop + 'px' })
        }, null, 4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windowedImages, (image) => {
          return (_openBlock(), _createElementBlock("div", {
            key: image.id,
            class: _normalizeClass(['thumbnail', {
                                                                                    'thumbnail-validated': image.is_validated && image.id !== (_ctx.selectedId ?? -1),
                                                                                    'thumbnail-invalidated': image.is_invalidated,
                                                                                    'thumbnail-selected': image.id === (_ctx.selectedId ?? -1) && !image.has_lines,
                                                                                    'thumbnail-has-lines': image.has_lines && image.id !== (_ctx.selectedId ?? -1),
                                                                                    'thumbnail-selected-has-lines': image.has_lines && image.id === (_ctx.selectedId ?? -1),
                                                                                    'thumbnail-selected-is-validated': image.is_validated && image.id === (_ctx.selectedId ?? -1),
                                                                                    'thumbnail-selected-is-invalidated': image.is_invalidated && image.id === (_ctx.selectedId ?? -1)}]),
            "data-image-id": image.id,
            onClick: ($event: any) => (_ctx.selectThumbnail(image)),
            onContextmenu: _withModifiers(($event: any) => (_ctx.openContextMenu($event, image)), ["prevent"])
          }, [
            _createElementVNode("img", {
              src: _ctx.thumbSrc[image.id],
              alt: image.file_name,
              title: image.file_name,
              width: _ctx.THUMB_W,
              height: _ctx.THUMB_H,
              loading: "lazy",
              decoding: "async",
              fetchpriority: "low",
              onError: ($event: any) => (_ctx.onThumbError(image))
            }, null, 40, _hoisted_4),
            (image.is_non_trackable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "✕"))
              : _createCommentVNode("", true),
            (_ctx.presenceByImage[image.id]?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presenceByImage[image.id], (u) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: u.key,
                      class: "presence-dot",
                      title: u.email,
                      style: _normalizeStyle(_ctx.dotStyle(u))
                    }, _toDisplayString((u.email || '?').charAt(0).toUpperCase()), 13, _hoisted_7))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 42, _hoisted_3))
        }), 128)),
        _createElementVNode("div", {
          class: "grid-pad",
          style: _normalizeStyle({ height: _ctx.padBottom + 'px' })
        }, null, 4)
      ], 4)
    ], 544),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, " Images: " + _toDisplayString(_ctx.numImgs), 1)
    ]),
    (_ctx.contextMenuVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "context-menu",
          style: _normalizeStyle({ top: _ctx.contextMenuY + 'px', left: _ctx.contextMenuX + 'px' })
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleNonTrackable && _ctx.toggleNonTrackable(...args)))
            }, _toDisplayString((_ctx.selectedThumbnail?.is_non_trackable || false) ? 'Valid' : 'Invalid'), 1),
            _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("li", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedImages && _ctx.deleteSelectedImages(...args)))
            }, "Delete")
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}